import {getCookie, setCookie, eraseCookie, getCookieDomain} from "@/store/util/cookieUtils";
import Vue from "vue";
import env from '@/env';

const COOKIE_NAME = "bml-token";
const COOKIE_TTL_DAYS = 7;

const persistAuthToken = (token) => {
	if (!token) {
		return;
	}

	const cookieDomain = getCookieDomain();
	localStorage.setItem("token", token);
	Vue.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
	setCookie(COOKIE_NAME, token, COOKIE_TTL_DAYS, cookieDomain);
};

const clearPersistedAuthToken = () => {
	const cookieDomain = getCookieDomain();
	eraseCookie(COOKIE_NAME, cookieDomain);
	localStorage.removeItem("token");
	delete Vue.axios.defaults.headers.common["Authorization"];
};

const state = {
	status: '',
	token: '',
	user: null,
}

const mutations = {
	auth_request(state) {
		state.status = 'loading'
	},
	auth_success(state, payload) {
		state.status = 'success'
		state.token = payload.token
		state.user = payload.user
		// Update Nexus Feedback widget with user session
		if (window.__nexusFeedback && payload.user) {
			window.__nexusFeedback.setUser({
				email: payload.user.email || payload.user.username || '',
				name: [payload.user.firstName, payload.user.lastName].filter(Boolean).join(' ') || '',
			});
		}
	},
	auth_error(state) {
		state.status = 'error'
	},
	auth_logout(state) {
		state.status = ''
		state.token = ''
		state.user = null
	},
}

const actions = {
	
	updateUserToken({ commit }, obj) {
		const vm = obj.vm;
		const token = obj.auth.token;
		const user = obj.auth.user;

		persistAuthToken(token);
		if (vm && vm.$axios) {
			vm.$axios.defaults.headers.common["Authorization" ] = `Bearer ${token}`;
		}

		commit({
			type: 'auth_success',
			token: token,
			user: user
		});
	},
	processLogout( {commit} ) {
		const jwt = getCookie(COOKIE_NAME);
		if(jwt || localStorage.getItem("token")){
			clearPersistedAuthToken();
		}

		commit('auth_logout')
	},
	async remoteJwtTokenCheck( {commit} ){
		// console.log('initiating jwt token check')
		return await Vue.axios.get(env.VUE_APP_AUTHHOST +'/jwt-token-check')
			.then( (resp ) => {
				const token = resp.data.jwttoken;
				const user = resp.data.user;
				persistAuthToken(token);
				
				commit({
					type: 'auth_success',
					token: token,
					user: user
				});
			} )
			.catch( () => {
				throw 'Fail JWT token validation';
			})
	}
}

const getters = {
	isLoggedIn: state => state.user != null,
	authStatus: state => state.status,
	currentUser: (state) => {
		return state.user
	},
	userRoles: (state) => {
		if(state.user){
			return state.user.roles;
		}
		else{
			return []
		}
	},
	isAdministrator: (state) => {
		return Array.isArray(state.user.roles) &&  state.user.roles.indexOf('ADMIN') > -1;
	},
	
}

export default {
	state,
	mutations,
	actions,
	getters
}
